export default {
  // All opened dialogs
  dialogs: []
};
